// extracted by mini-css-extract-plugin
module.exports = {"car":"Car_car__u6b8C","title":"Car_title__1LxMQ","description":"Car_description__3j3o0"};